<div class="summary">
  @if (data?.left) {
    <div
      class="left"
      >
      <div class="label">{{ data?.left?.label }}</div>
      <div
        class="summary-bar"
        >
        <div
          class="bar"
        [ngStyle]="{
            'width': data?.left?.value + '%'
          }"
        ></div>
      </div>
      @if (data?.left?.statistics) {
        <div
          class="summary-text"
          >
          {{ data?.left?.statistics }}
        </div>
      }
    </div>
  }
  @if (data?.right) {
    <div
      class="right"
      >
      @if (data?.right?.label) {
        <div
          class="label"
          >
          {{ data?.right?.label }}
        </div>
      }
      <div
        class="summary-bar"
        >
        <div
          class="bar"
        [ngStyle]="{
            'width': data?.right?.value + '%'
          }"
        ></div>
      </div>
      @if (data?.right?.statistics) {
        <div
          class="summary-text"
          >
          {{ data?.right?.statistics }}
        </div>
      }
    </div>
  }
</div>
